import gsap from 'gsap';

export default function initHeroForm() {
    const heroBlackGradient = document.querySelector('.heroform-black-gradient');
    const heroNumbers = document.querySelector('.heroform-numbers');
    const heroList = document.querySelector('.heroform-list ul');

    const timeline = gsap.timeline({ paused: true });

    if (heroBlackGradient) {
        timeline.from(heroBlackGradient, {
            opacity: 0,
            duration: .5
        });
    }

    if (heroList) {
        timeline.from(heroList.children, {
            x: -100,
            opacity: 0,
            duration: 0.35,
            stagger: 0.2
        });
    }

    if (heroNumbers) {
        timeline.from(heroNumbers, {
            y: 100,
            opacity: 0,
            duration: .5
        });
    }

    const startAnimation = () => {
        timeline.play();
    };

    const mouseMoveHandler = () => {
        clearTimeout(timeoutId);
        startAnimation();
        document.removeEventListener('mousemove', mouseMoveHandler);
    };

    const timeoutId = setTimeout(startAnimation, window.innerWidth <= 768 ? 500 : 500);
    document.addEventListener('mousemove', mouseMoveHandler, { once: true });
}